"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serialization_1 = require("../serialization");
const typeDefs_1 = require("./typeDefs");
const result_1 = require("../result");
const NamespacedNamed_1 = require("../NamespacedNamed");
const typeDefinitionNs = NamespacedNamed_1.namespace("json-types.org/type-definition");
const typeRef = serialization_1.sRef(() => sType);
const sUnionType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("union"),
        of: serialization_1.sArray(typeRef),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.UnionTypeDef,
    serialize: val => ({ kind: val.kind, of: val.of }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.UnionTypeDef(val.of)),
})
    .defineAs(typeDefinitionNs("UnionType"));
const sIntersectionType = serialization_1.sArray(typeRef)
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.IntersectionTypeDef,
    serialize: val => val.of,
    deserialize: val => result_1.deserializationValue(new typeDefs_1.IntersectionTypeDef(val)),
})
    .defineAs(typeDefinitionNs("IntersectionType"));
const sStringType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("string"),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.StringTypeDef,
    serialize: val => ({ kind: val.kind }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.StringTypeDef()),
})
    .defineAs(typeDefinitionNs("StringType"));
const sBooleanType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("boolean"),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.BooleanTypeDef,
    serialize: val => ({ kind: val.kind }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.BooleanTypeDef()),
})
    .defineAs(typeDefinitionNs("BooleanType"));
const sNumberType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("number"),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.NumberTypeDef,
    serialize: val => ({ kind: val.kind }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.NumberTypeDef()),
})
    .defineAs(typeDefinitionNs("NumberType"));
const sAnyType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("any"),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.AnyTypeDef,
    serialize: val => ({ kind: val.kind }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.AnyTypeDef()),
})
    .defineAs(typeDefinitionNs("AnyType"));
const sLiteralType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("literal"),
        value: serialization_1.sUnion(serialization_1.sString, serialization_1.sNumber, serialization_1.sBoolean),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.LiteralTypeDef,
    serialize: val => ({ kind: val.kind, value: val.value }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.LiteralTypeDef(val.value)),
})
    .defineAs(typeDefinitionNs("LiteralType"));
const sObjectProperty = serialization_1.sObject({
    properties: {
        type: typeRef,
        optional: serialization_1.field({
            serializer: serialization_1.sBoolean,
            optional: { withDefault: false },
        }),
    },
})
    .refine({
    canSerialize: (item) => item instanceof typeDefs_1.ObjectPropertyDef,
    serialize: val => ({ type: val.type, optional: val.optional }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.ObjectPropertyDef(val.type, val.optional, undefined)),
})
    .defineAs(typeDefinitionNs("ObjectProperty"));
const sArrayType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("array"),
        of: typeRef,
    },
})
    .refine({
    canSerialize: (item) => item instanceof typeDefs_1.ArrayTypeDef,
    serialize: val => ({ kind: val.kind, of: val.itemType }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.ArrayTypeDef(val.of)),
})
    .defineAs(typeDefinitionNs("ArrayType"));
const sObjectType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("object"),
        properties: serialization_1.sMap(sObjectProperty),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.ObjectTypeDef,
    serialize: val => ({ kind: val.kind, properties: val.properties }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.ObjectTypeDef(val.properties)),
})
    .defineAs(typeDefinitionNs("ObjectType"));
const sMapType = serialization_1.sObject({
    properties: {
        kind: serialization_1.sLiteral("map"),
        valueType: typeRef,
    },
})
    .refine({
    canSerialize: (item) => item instanceof typeDefs_1.MapTypeDef,
    serialize: val => ({ kind: val.kind, valueType: val.valueType }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.MapTypeDef(val.valueType)),
})
    .defineAs(typeDefinitionNs("MapType"));
const sTypeRef = serialization_1.sNamespacedName
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.TypeRefDef,
    serialize: val => val.namespacedName,
    deserialize: val => result_1.deserializationValue(new typeDefs_1.TypeRefDef(val)),
})
    .defineAs(typeDefinitionNs("TypeReference"));
const sType = serialization_1.sUnion(sUnionType, sIntersectionType, sStringType, sBooleanType, sNumberType, sAnyType, sLiteralType, sObjectType, sMapType, sArrayType, sTypeRef).defineAs(typeDefinitionNs("Type"));
exports.sTypePackage = serialization_1.sObject({
    properties: {
        packageId: serialization_1.sNamespace,
        typeDefinitions: serialization_1.sMap(sType),
    },
})
    .refine({
    canSerialize: (val) => val instanceof typeDefs_1.TypePackageDef,
    serialize: val => ({
        packageId: val.packageNs,
        typeDefinitions: val.definitions,
    }),
    deserialize: val => result_1.deserializationValue(new typeDefs_1.TypePackageDef(val.packageId, val.typeDefinitions)),
})
    .defineAs(typeDefinitionNs("TypeDefinitions"));
//# sourceMappingURL=typeDefsSerializer.js.map